import { useInvoicesPage } from "@/hooks/useInvoicesPage";
import type { UseInvoicesPageReturn } from "@/types/invoices";
import { createContext, useContext } from "react";
import type { ReactNode } from "react";

const InvoicesContext = createContext<UseInvoicesPageReturn | null>(null);

const InvoicesProvider = ({ children }: { children: ReactNode }) => {
  const value = useInvoicesPage();
  return <InvoicesContext value={value}>{children}</InvoicesContext>;
};

const useInvoices = (): UseInvoicesPageReturn => {
  const ctx = useContext(InvoicesContext);
  if (!ctx) throw new Error("useInvoices must be used within InvoicesProvider");
  return ctx;
};

export { InvoicesContext, InvoicesProvider, useInvoices };
